import { JustifyContentOptions } from '../Types/JustifyContentOptions';

const justifyContent = (property: JustifyContentOptions): string =>
    ({
        start: 'flex-start',
        end: 'flex-end',
        center: 'center',
        stretch: 'stretch',
        around: 'space-around',
        between: 'space-between',
        evenly: 'space-evenly',
    }[property] || 'flex-start');

export default justifyContent;
